import { FormProvider, useForm } from "react-hook-form";
import { PaziaFormButton, PaziaLoader, PaziaSelect } from "components/atoms";
import { useBreadcrumbSettings, shopApi } from "api/shop";
import { useToaster } from "utils";
import { useState, useEffect } from "react";

interface FormValues {
  fontFamily: string;
}

export const ShopBreadcrumbsForm = () => {
  const { breadcrumbSettings, isLoading, invalidate } = useBreadcrumbSettings();
  const { showSuccess, showError } = useToaster();
  const [isSaving, setIsSaving] = useState(false);

  const methods = useForm<FormValues>({
    defaultValues: {
      fontFamily: breadcrumbSettings?.fontFamily ?? "",
    },
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (breadcrumbSettings) {
      reset({
        fontFamily: breadcrumbSettings.fontFamily ?? "",
      });
    }
  }, [breadcrumbSettings, reset]);

  const onSubmit = async (data: FormValues) => {
    setIsSaving(true);
    try {
      await shopApi.updateBreadcrumbSettings({
        fontFamily: data.fontFamily || undefined,
      });
      showSuccess("Zapisano ustawienia breadcrumbów");
      invalidate();
    } catch (error) {
      showError("Nie udało się zapisać ustawień breadcrumbów");
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="grid max-w-3xl gap-6">
        <div>
          <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200">Breadcrumbs</h3>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Czcionka breadcrumbów na całym sklepie
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <PaziaSelect
            name="fontFamily"
            label="Rodzaj fontu"
            options={[
              { value: "", label: "Domyślny (z motywu)" },
              { value: "Inter, sans-serif", label: "Inter" },
              { value: "Poppins, sans-serif", label: "Poppins" },
              { value: "'Playfair Display', serif", label: "Playfair Display" },
              { value: "system-ui, sans-serif", label: "Systemowy bezszeryfowy" },
              { value: "Georgia, serif", label: "Georgia (szeryfowy)" },
              { value: "'Courier New', monospace", label: "Monospace" },
            ]}
          />
        </div>

        <div className="flex justify-start">
          <PaziaFormButton disabled={isSaving} />
        </div>
      </form>
    </FormProvider>
  );
};
